// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3W7oj","requiredAsterisk":"Info_requiredAsterisk__3cF9U"};